import { Card, CardBody, CardHeader, Col } from "reactstrap";
import { VisitorsHeading } from "../../../../utils/Constant";
import ReactApexChart from "react-apexcharts";
import { visitorChartData } from "../../../../Data/Widgets/WidgetsChartData";
import { H3, SVG } from "../../../../AbstractElements";
import CardHeaderDropDown from "../../CommonCardHeader/CardHeaderDropDown";

const Visitors = () => {
  return (
    <Col xxl="5" xl="3" md="12" className="box-col-12">
      <Card className="visitor-card">
        <CardHeader className="card-no-border pb-0">
          <div className="header-top">
            <H3 className="m-0">
              {VisitorsHeading}
              <span className="f-14 font-primary f-w-500 ms-1">
                <SVG className="svg-fill me-1" iconId="user-visitor"/>
                (+2.8)
              </span>
            </H3>
            <div className="card-header-right-icon">
              <CardHeaderDropDown mainTitle="Yearly" firstItem="Today" secondItem="Tomorrow" thirdItem="Yesterday"/>
            </div>
          </div>
        </CardHeader>
        <CardBody className="pt-3">
          <div className="visitors-container">
            <ReactApexChart options={visitorChartData} series={visitorChartData.series} type="bar" height={270}/>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default Visitors;
